import { LazyLog } from '@melloware/react-logviewer';
import SingleAssetSubPage from '@customer/templates/single-asset-sub-page/SingleAssetSubPage';
import styles from './SingleAssetTerminal.module.scss';
import { useTranslation } from 'react-i18next';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

class TerminalLogData {
  casWebReceiveTime = '';
  gpsTime = '';
  rawNmea = '';
}

const getUrl = window.location;
const baseUrl = (getUrl.protocol === 'https:' ? 'wss://' : 'ws://') + getUrl.host;

export function SingleAssetTerminal() {
  const { assetId } = useParams();
  const { t } = useTranslation();

  const { showTimeAndDateWithMillisecondsFromIso, showTimeAndDateWithSecondsFromIso } =
    useLocaleFormatter();

  const formatDeviceMessage = (terminalLogData: string): string => {
    const message: TerminalLogData = JSON.parse(terminalLogData);

    if (message.rawNmea.length > 0) {
      return t('DeviceCommsMessage', {
        casWebReceiveTime: showTimeAndDateWithSecondsFromIso(message.casWebReceiveTime),
        gpsTime: showTimeAndDateWithMillisecondsFromIso(message.gpsTime),
        message: message.rawNmea,
      });
    } else {
      return t('WaitingForData');
    }
  };

  const wsUrl = useMemo<string | undefined>(() => {
    if (assetId) {
      const wsUrl = `${baseUrl}/api/ws/assets/${assetId}/terminal`;
      console.debug('Using WS URL: ', wsUrl);

      return wsUrl;
    }

    return undefined;
  }, [assetId]);

  return (
    <SingleAssetSubPage>
      <div className={styles.container}>
        <LazyLog
          style={{
            backgroundColor: 'var(--surface-neutral-default)',
          }}
          url={wsUrl}
          websocket
          websocketOptions={{
            onOpen: o => console.debug('on open', o),
            onError: o => console.debug('on error', o),
          }}
          enableSearch={true}
          follow={false}
          formatPart={text => formatDeviceMessage(text)}
        />
      </div>
    </SingleAssetSubPage>
  );
}

export default SingleAssetTerminal;
